import {
	comMapping
} from "@/components/util/Function/comMapping";
export function getdata() {
	let obj = {
		searchlist: [{
				prop: "subType",
				label: '类型',
				type: "select",
				selectval: comMapping.$lx
			},
			{
				prop: "status",
				label: '任务状态',
				type: "select",
				selectval: [{
					label: "未开始",
					value: "1"
				}, {
					label: "运行中",
					value: "2"
				}, {
					label: "执行成功",
					value: "3"
				}, {
					label: "执行失败",
					value: "4"
				}]
			},
		],
		searchdata: {
			subType: '',
			status: '',
		},
		headData: [{
				title: "类型",
				prop: "subType",
				width: "100",
				custom: true,
				issort: true,
			},
			{
				title: "文件名",
				prop: "downloadPath",
				width: "120",
				issort: true,
			},
			{
				title: "任务状态",
				prop: "status",
				width: "120",
				custom: true,
				issort: true,
			},
			{
				title: "创建时间",
				prop: "createTime",
				width: "120",
				issort: true,
			},
			{
				title: "完成时间",
				prop: "updateTime",
				width: "120",
				issort: true,
			},
			{
				title: "创建者",
				prop: "creator",
				width: "120",
				issort: true,
			}, {
				title: "报表生成条件",
				prop: "params",
				width: "140",
				issort: true,
			},
			{
				title: "操作",
				prop: "cz",
				width: "200",
				custom: true
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
	}
	return obj
}
